import { render, staticRenderFns } from "./NewAppointmentSidebar.vue?vue&type=template&id=868d5502"
import script from "./NewAppointmentSidebar.vue?vue&type=script&lang=js"
export * from "./NewAppointmentSidebar.vue?vue&type=script&lang=js"
import style0 from "./NewAppointmentSidebar.vue?vue&type=style&index=0&id=868d5502&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports